import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CacheService } from '../common/services/cache.service';
import { IconComponent } from '../common/components/general/icon/icon.component';
import { AuthService } from '../common/services/auth/auth.service';

@Component({
  selector: 'nuc-error',
  standalone: true,
  imports: [IconComponent],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss'
})
export class ErrorComponent implements OnInit {
  statusCode: number;
  errorMessage: string;
  unauthorizedUser: boolean = false;

  constructor(private router: Router, private cacheService: CacheService, private authService: AuthService) {}
  
  ngOnInit(): void {
    const authError = this.cacheService.getFromCache('AUTH_ERROR');
    
    if (authError && authError.unauthorizedUser) {
      this.statusCode = undefined;
      this.errorMessage = authError.errorMessage;
      this.unauthorizedUser = true;
      this.cacheService.removeFromCache('AUTH_ERROR');
    } else {
      const navigation = this.router.getCurrentNavigation();
      this.statusCode = navigation?.extras?.state?.['statusCode'];
    }  
    if(this.statusCode === 401){
      this.cacheService.clearCache();
    }
  }

  goBackToLogin(): void {
    this.cacheService.clearCache();
    this.authService.login('pf', null);
  }
}
